export enum PermissionConsts {
    Pages_Users = 'Pages.Users',
    User_Create = 'User.Create',
    User_Detail = 'User.Detail',
    User_Edit = 'User.Edit',
    User_Delete = 'User.Delete',
    User_Get = 'User.Get',

    // questionnaire section
    Questionnaire_CreateList = 'Questionnaire.CreateList',
    Questionnaire_GetAll = 'Questionnaire.GetAll',
    Questionnaire_Delete = 'Questionnaire.Delete',

    // Interviews
    Interview_GetAll = 'Interview.GetAll',
    Interview_Get = 'Interview.Get',
}
